module.exports = __webpack_public_path__ + "static/allbibs-7734f86ef9c7ff0607c8066ff8b1cf96.jpeg";